export enum CdCarePlanStatus {
  Open,
  WaitingForMentor,
  WaitingForEl,
  Finished
}
